import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
  size?: 'md' | 'lg';
};
export function Countdown({
  tone = 'dark',
  size = 'md'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'HRS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEC'
  }];
  const digitClass = size === 'lg' ? 'text-5xl sm:text-6xl' : 'text-3xl sm:text-4xl';
  const boxClass = tone === 'light' ? 'bg-white/15 text-white' : 'bg-navy-900 text-white ring-1 ring-white/10';
  return <div className="flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-75" data-mp="3259haztx35te">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-76" data-mp="15bg4oelhfb8a" data-mpi={i}>
          <div className={`flex min-w-[76px] flex-col items-center rounded-xl px-3 py-2 sm:min-w-[92px] ${boxClass}`} data-id="element-77" data-mp="15a4zqbgavxfl">
            <span className={`font-display font-black tabular-nums leading-none ${digitClass}`} data-id="element-78" data-mp="xytv6aq2kr33">
              {unit.value}
            </span>
            <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-white/50" data-id="element-79" data-mp="17qgaoj9fxcbn">
              {unit.label}
            </span>
          </div>
          {i < units.length - 1 && <span aria-hidden="true" className={`font-display font-black leading-none text-gold ${digitClass}`} data-id="element-80" data-mp="f2kinrutg8l7">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}